import React from 'react';
import TextField from 'components/Typography/TextField';
import Icon from 'components/DesignSystem/Icon';
import Selector from 'components/DesignSystem/Selector';
import { Col } from 'react-bootstrap';
import Tooltip from 'components/Typography/Tooltip';
import { cssVar } from 'constants/theme';
import './index.scss';

export default function ColumnHeader({
  title,
  children,
  filterless = false,
  className = '',
  value = [],
  setValue = () => {},
  md,
}: {
  title: string;
  children?: React.ReactNode;
  filterless?: boolean;
  className?: string;
  value?: string[];
  setValue?: React.Dispatch<React.SetStateAction<string[]>>;
  md: number;
}) {
  const filterIcon = (
    <Icon iconType="filter" color={cssVar('text-strong')} />
  );

  return (
    <Col md={md} className={`mt-1 d-flex align-items-center justify-content-start gap-1 ${className}`}>
      { !filterless && (
        <div className="ht-filter-button-container">
          <Selector
            value={value}
            setValue={setValue}
            search
            containerClassName="ht-filter-selector"
            fixedTitle={filterIcon}
            clearOptionsButton
          >
            { children }
          </Selector>
          {value.length !== 0 && (<Tooltip>{ value.length }</Tooltip>)}
        </div>
      )}
      <TextField>{ title }</TextField>
    </Col>
  );
}
